import firebase from 'firebase'
require('firebase/firestore')
require('firebase/auth')

  // Initialize Firebase
  const config = {
  //var config = {
    apiKey: "AIzaSyCWls80syK6St6Bah8bacExZP8YTgqgEOA",
    authDomain: "novablitzhq.firebaseapp.com",
    databaseURL: "https://novablitzhq.firebaseio.com",
    projectId: "novablitzhq",
    storageBucket: "novablitzhq.appspot.com",
    messagingSenderId: "384675602179"
  };

  if (!firebase.apps.lenght) {
    firebase.initializeApp(config);
  }

const db = firebase.firestore();
const auth = firebase.auth();

export {
  auth,
  db
}


//export const db = firebase.firestore()



// WEBPACK FOOTER //
// ./src/firebase/firebase.js